import { mapGetters } from "vuex";
import event_bus from "../../shared/utils/event_bus";
import api from "../../core/http/axios";
import routes from "../../core/config/api-ontick.routes";
export default {
  data() {
    return {
      button_is_disabled: false,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    async stop(order_data) {
      this.button_is_disabled = true;
      try {
        const account_id = this.getSelectedAccount.account_id;
        const bo_id = order_data.bo_id;
        const { data } = await api.post(routes.STOP_BEST, {
          account_id,
          bo_id,
        });
        await this.$swal("Best parada", data.msg, "success");
        event_bus.$emit("BEST_STOPPED");
        this.$emit("stop");
      } catch (err) {
        this.$swal("Erro", err.data.msg, "error");
      } finally {
        this.button_is_disabled = false;
      }
    },
  },
};
